export default "__VITE_ASSET__d0ce358f__"